"use client"

import "./styles.css"
import { useEffect, useState } from "react"
import { GenericErrorMessage } from "@/components/GenericErrorMessage/GenericErrorMessage.component"
import { useCaptureException } from "@/hooks/use-capture-exception.hook"
import { captureClientException } from "@/services/logging/capture-client-exception"
import type { Locale } from "@/ts/locale/locale.types"
import { getCurrentSiteConfiguration } from "@/utilities/site-configuration/get-current-site-configuration"

export default function GlobalError({
  error,
  reset,
}: {
  readonly error: Error & { readonly digest?: string }
  readonly reset: () => void
}) {
  const [locale, setLocale] = useState<Locale>("en")
  const [domain, setDomain] = useState<string>("finanswatch.dk")

  useCaptureException(error)

  useEffect(() => {
    const grabLocale = async () => {
      const { locale, domain } = await getCurrentSiteConfiguration()
      setLocale(locale)
      setDomain(domain)
    }

    grabLocale().catch(captureClientException)
  }, [])

  return (
    <html lang="en" suppressHydrationWarning={true}>
      <body
        className={`bg-white text-black theme-${domain} font-body`}
        suppressHydrationWarning={true}
      >
        <main className="flex min-h-screen items-center justify-center p-4">
          <GenericErrorMessage locale={locale} reset={reset} />
        </main>
      </body>
    </html>
  )
}
